import { rankingData } from '@/mocks/home';

export default function RankingSection() {
  const trendIcons: Record<string, string> = {
    up: 'ri-arrow-up-line',
    down: 'ri-arrow-down-line',
    stable: 'ri-subtract-line',
  };
  const trendColors: Record<string, string> = {
    up: 'text-primary-500',
    down: 'text-foreground-400',
    stable: 'text-foreground-400',
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              热度榜单
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              实时热度排行，看看大家都在追什么
            </p>
          </div>

          <div className="flex flex-col gap-3">
            {rankingData.map((item) => (
              <div
                key={item.id}
                className="group flex items-center gap-3 md:gap-5 bg-background-50 rounded-lg border border-secondary-200/70 p-3 md:p-4 hover:border-primary-300 transition-all duration-300 cursor-pointer"
              >
                <div className="w-8 md:w-10 h-8 md:h-10 flex items-center justify-center shrink-0">
                  {item.rank <= 3 ? (
                    <span className="font-heading text-lg md:text-xl font-bold text-primary-500">
                      {item.rank}
                    </span>
                  ) : (
                    <span className="text-sm md:text-base font-semibold text-foreground-500">
                      {item.rank}
                    </span>
                  )}
                </div>

                <div className="relative w-16 md:w-20 h-10 md:h-12 rounded overflow-hidden shrink-0">
                  <img
                    src={item.image}
                    alt={`木瓜影视${item.title}`}
                    title={`木瓜影视-${item.title}-热度榜单`}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                    }}
                  />
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors truncate">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 truncate">{item.subtitle}</p>
                </div>

                <div className="hidden sm:flex items-center gap-1.5 shrink-0">
                  <i className={`${trendIcons[item.trend]} text-sm ${trendColors[item.trend]}`}></i>
                  <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">
                    {item.hot}
                  </span>
                </div>

                <div className="shrink-0">
                  <span className="inline-flex items-center gap-1 text-xs text-primary-500 font-medium whitespace-nowrap">
                    观看 <i className="ri-arrow-right-s-line text-sm"></i>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}